var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"95de841b9b9e9199336b2e56c0e21f94513a7b47"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"95de841b9b9e9199336b2e56c0e21f94513a7b47"};
      